<template>
    <v-app>
        <LogIn v-if="!user" />
        <div v-if="user">

        <v-app-bar color="light-blue accent-4" dark fixed>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title>Sidon</v-toolbar-title>

            <div class="flex-grow-1"></div>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="on">
                        <v-btn icon @click="openDialog">
                            <v-icon>mdi-calendar-plus</v-icon>
                        </v-btn>
                    </span>
                </template>
                <span>Lägg till jourtid</span>
            </v-tooltip>
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            absolute
            left
            temporary
            >
            <template v-slot:prepend v-if="user && user.displayName">
                <v-list-item two-line>
                    <v-list-item-avatar>
                        <img :src="user.photoURL">
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>{{ user.displayName }}</v-list-item-title>
                        <v-list-item-subtitle>Inloggad</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-btn icon @click="logout">
                        <v-icon>mdi-exit-to-app</v-icon>
                    </v-btn>
                </v-list-item>
            </template>

            <v-divider></v-divider>
            <v-list
                nav
                dense
                >
                <v-list-item-group
                    v-model="group"
                    active-class="blue--text text--accent-4"
                    >
                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>mdi-calendar-month</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <router-link to="/">
                                <v-list-item-title>Jourschema</v-list-item-title>
                            </router-link>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>mdi-ferry</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <router-link to="/units">
                                <v-list-item-title>Enheter</v-list-item-title>
                            </router-link>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>mdi-file-chart</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <router-link to="/reports">
                                <v-list-item-title>Rapporter</v-list-item-title>
                            </router-link>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider />

                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>mdi-office-building</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <router-link to="/stations">
                                <v-list-item-title>Stationer</v-list-item-title>
                            </router-link>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-content v-if="user" :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'pa-4': $vuetify.breakpoint.mdAndUp}" style="margin-top: 64px;">
            <router-view />
            <NoStation v-if="stations == null || stations.length === 0" />
            <div class="text-center">
                <v-dialog
                    v-model="showDialog"
                    width="500">
                    <DayInput v-if="user" :closeDialog="closeDialog" />
                </v-dialog>
            </div>
        </v-content>
        </div>
    </v-app>
</template>

<script>
/* eslint-disable */
import LogIn from './components/LogIn'
import DayInput from "./components/DayInput"
import NoStation from "./components/station/NoStation"

const AUTH_STATE = {
    UNKNOWN: 'unknown',
    AUTHORIZED: 'authorized',
    UNAUTHORIZED: 'unauthorized',
}

import Vue from 'vue'

import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/firestore'
import VueFirestore from 'vue-firestore'

Vue.use(VueFirestore)

// const db = firebase.firestore()

export default {
    name: "App",
    components: {
        LogIn,
        DayInput,
        NoStation,
    },
    firestore () {
        return {
            // Collection
            stations: db.collection('stations'),
            users: db.collection('users'),
        }
    },
    mounted: function() {
        const vm = this
        fb.auth().onAuthStateChanged(function(firebaseUser) {
            if (firebaseUser) {
                const uid = firebaseUser.uid
                const displayName = firebaseUser.displayName
                const photoURL = firebaseUser.photoURL
                const lastLoggedIn = new Date()
                const data = {
                    displayName,
                    photoURL,
                    lastLoggedIn
                }
                db.collection('users').doc(uid).update(data)
                    .then(() => {
                        return db.collection('users').doc(uid).get()
                    })
                    .then((snap) => {
                        vm.user = snap.data()
                        const station = vm.user.stations[0]
                        vm.$stationId = station.id
                    })
                    .catch(console.error)
            } else {
                vm.user = null
            }
        })
    },
    data() {
        return {
            drawer: false,
            group: null,

            user: null,
            //authState: AUTH_STATE.UNKNOWN,
            showDialog: false,
        }
    },
    methods: {
        openDialog: function() {
            this.showDialog = true;
        },
        closeDialog: function() {
            this.showDialog = false;
        },
        logout: async function() {
            try {
                await firebase.auth().signOut()
                console.log('Sign out successful!!')
            }
            catch(err) {
               console.error(err)
            }
        }
    },
    computed: {
      chartWidth() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 345
          case 'sm': return 400
          case 'md': return 500
          case 'lg': return 600
          case 'xl': return 800
        }
        return 0
      },
    },
};
</script>
